import React from "react";
import DesktopMenu from "./component/DesktopMenu";
import MobileMenu from "./component/MobileMenu";

import TwitterIcon from '@mui/icons-material/Twitter';
import TelegramIcon from '@mui/icons-material/Telegram';
import CustomeBtn from "../CustomBtn";
import CustomButton from "../CustomBtn";

const LockerMenu = (props) => {
  const menuList = [
    // You can pass 4 perameters for menu title, link, target and customClass

    {
      title: "HOME",
      link: "/",
    },
    {
      title: "TOKENOMICS",
      link: "/tokenomics",
    },
    {
      title: "ROADMAP",
      link: "/roadmap",
    },
    {
      title: <CustomButton>CONTRACT</CustomButton>,
      link: "",
    },
  ];
  return (
    <>
    <div
      data-aos="fade-zoom-in"
      data-aos-easing="ease-in"
      data-aos-delay="400"
      data-aos-duration="400"
      data-aos-offset="0">
      <DesktopMenu menuList={menuList} />
      <MobileMenu menuList={menuList} />
    </div>
    </>
  );
};

export default LockerMenu;
